module.exports = __webpack_public_path__ + "img/tencent-meeting.2d860cac.png";